import { useI18n } from "@/hooks/useI18n";
import { Text, Flex, Image } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { BXButton } from "@/styles/index";

const Result = () => {
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <Flex
      flexDirection={"column"}
      style={{ backgroundColor: "#fff" }}
      height={"auto"}
      minHeight={"100vh"}
      width={["calc(100% - 30px)", "400px"]}
      overflow={"hidden"}
      margin={"0 auto"}
      mt={"70px"}
      color={"#010313"}
      fontSize={"14px"}
      alignItems={"center"}
    >
      <Image
        src="../../../wwwsite/images/kyc/success.svg"
        alt=""
        w={"40px"}
        h={"40px"}
      />

      <Text fontSize={"24px"} fontWeight={600} mt={"10px"}>
        {t("cWYINWiSUUdFuDAImP")}
      </Text>
      <Text mt={"10px"}>{t("YXrqAGUqprWfOCeiSGX")}</Text>
      <BXButton
        mt="40px"
        onClick={() => navigate("/trade/wallet")}
        className="cancel"
      >
        {t("WbPTckCFMKtPHgAlL")}
      </BXButton>
    </Flex>
  );
};

export default Result;
